
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { SummaryPayServiceModel } from '@/models/summary-payservice';
import { PayServiceModel } from '@/models/payservice';

import ListPayService from './components/ListPayService.vue';
import FilterBox from './components/FilterBox.vue';

import authService from '@/services/auth-services';
import payserviceServices from '@/services/payservice-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListPayService,
        FilterBox,
        Loading,
        Paging,
        ConfirmModal
    }
})
export default class MainPayService extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private summaryOrder: SummaryPayServiceModel = new SummaryPayServiceModel();
    private listPayService: PayServiceModel[] = [];
    private isLoading = false;
    private customerInfo: any = {};
    private showNextConfirm = true;
    private isConfirm = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        await this.getCustomersInfo();
        this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryPayServiceModel();
        const result = await payserviceServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListPayService: PayServiceModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus2: result.data.summary.TotalStatus2 || 0,
                TotalStatus3: result.data.summary.TotalStatus3 || 0,
                TotalStatus4: result.data.summary.TotalStatus4 || 0,
                TotalStatus5: result.data.summary.TotalStatus5 || 0
            };

            for (const item of result.data.data) {
                const payservice = new PayServiceModel();
                payservice.id = item.ID;
                payservice.status = item.Status;
                payservice.amount = item.Amount;
                payservice.fee = item.Fee;
                payservice.feeAmount = item.FeeAmount;
                payservice.totalAmount = item.TotalAmount;
                payservice.createdDate = item.CreatedDate;
                payservice.statusDetail = DATA.payserviceStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };

                tmpListPayService.push(payservice);
            }
            this.listPayService = tmpListPayService;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'Amount',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private createNewPayService() {
        const routeData = this.$router.resolve({ name: 'payservice-new' });
        window.open(routeData.href, '_blank');
    }
    
    private payOrder() {
        if (this.customerInfo.Wallet >= this.amountNeedPay) {
            const listDeposit = this.listPayService.filter(x => x.status === 3 && x.isChecked === true);
            this.modalContent = this.onModalContentDeposit(listDeposit, this.amountNeedPay);
            this.isConfirm = true;
            this.showNextConfirm = true;
        } else {
            this.modalContent = `<div style="color: #111;">Số tiền trong ví của bạn không đủ để thanh toán.</div>
                                <div>Tiền cần cọc: <span class="fb">${formatNumber(this.amountNeedPay, '0,0')} VND</span></div>
                                <div>Ví: <span class="fb">${formatNumber(this.customerInfo.Wallet, '0,0')} VND</span></div>
                                <div class="text-danger">Hãy nạp tiền để tiếp tục thanh toán!</div>`;
            this.isConfirm = true;
            this.showNextConfirm = false;
        }
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    get amountNeedPay() {
        return this.listPayService.reduce((amount: number, order: PayServiceModel) => {
            return amount + (order.isChecked === true && order.status === 3 ? order.totalAmount || 0 : 0)
        }, 0);
    }

    get totalChoose() {
        return this.listPayService.filter(x => x.isChecked === true).length;
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listPayService = this.listPayService.map(x => {
            return {
                ...x,
                isChecked: x.status === 3 ? isCheckAll : x.isChecked
            }
        });
    }

    private onModalContentDeposit(listDeposit: PayServiceModel[], amountNeedDeposit) {
        let modalContent = `<div class="modal-happy">Bạn có muốn thanh toán cho <span class="fb text-danger">${listDeposit.length}</span> đơn dưới đây không?
                            <div>
                                <ul>`
        for(const order of listDeposit) {
            modalContent += `<li>`;
            modalContent += `<div>[Mã đơn: <span class="fb">${order.id}</span>]<span class="text-danger ml10 fr">${ formatNumber(order.totalAmount, '0,0') } <i>VND</i></span></div>`
            modalContent += `</li>`;
        }

        modalContent += `<li><div class="text-danger fb">TỔNG TIỀN<span class="fb ml10 fr">${ formatNumber(amountNeedDeposit, '0,0') } <i>VND</i></span></div></li>`;

        modalContent += `</ul></div>`;
        

        return modalContent;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.submitDepositOrder();
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private async submitDepositOrder() {
        this.isLoading = true;
        const dataRequest = {
            type: 2,
            ids: this.listPayService
                    .filter(x => x.status === 3 && x.isChecked === true)
                    .map(x => x.id)
        }
        const result = await payserviceServices.updateMulti(dataRequest);

        if (result && result.status === 200 && result.data.data.status === true) {
            Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Thanh toán thành công!'});
            this.getCustomersInfo();
            this.loadData();
        } else {
            this.isLoading = false;
        }
    }
}
